import { ChangeDetectionStrategy, Component } from '@angular/core';
import {MdbNotificationRef} from "mdb-angular-ui-kit/notification";

@Component({
    selector: 'app-toast',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss'
})
export class ToastComponent {
  text: string | null = null;
  type: string = 'primary';

  constructor(public notificationRef: MdbNotificationRef<ToastComponent>) {
    const data = (this.notificationRef as unknown as { data?: { text?: string; type?: string } }).data;
    if (data) {
      this.text = data.text ?? null;
      this.type = data.type ?? 'primary';
    }
  }
}
